import React, { useRef, useEffect, useState ,useContext} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CommonStyle from "../Styles/Common.module.css";
import FontStyle from "../Styles/FontStyle.module.css";
import ButtonStyle from "../Styles/Button.module.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import Search from "./Search";
import { LuSearch } from "react-icons/lu";
import { IMAGE_BASE_URL, API_BASE_URL } from "./../../constants";
import LoginPopup from '../Auth/Login/LoginPopup';
import AuthContext from "../../store/auth-context";
import axios from "axios";
import LocationCover from '../Browse/LocationCover';
import "react-multi-carousel/lib/styles.css";
import { 
  PostSearchDetails,
  PostSearchFilter,
  getMapCoordinates
} from "../../services/routes.services";
import { Helmet } from "react-helmet";
const VirtualTour = (props) => {
  const authCtx = useContext(AuthContext);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [searchResultValue, setSearchResultValue] = useState();
  const [searchCityValue, setSearchCityValue] = useState();
  const [checkedMap, setCheckedMap] = React.useState(true);
  const [link, setLink] = useState(false);
  const [propertyType, setPropertyType] = useState("");
  const [filterCategoryArray, setFilterCategoryArray] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [searchBox, setSearchBox ] = useState(false);
  const [activeMarker, setActiveMarker] = useState(false);



  const showSearchHandler = ()=>{
    setSearchBox(true)
  }
  const closeSearchHandler = ()=>{
    setSearchBox(false)
  }
  const rangeRef = useRef(null);
  const priceRef = useRef(null);

  //Get Location Data
  const ActivityValue= localStorage.getItem("SearchActivity");
  const locationValue = localStorage.getItem("SearchLocation");
  const crewValue = localStorage.getItem("SearchCategory");
  const shootValue = localStorage.getItem("SearchActivityDay");
  //
  
//   useEffect(() => {
    
//     PostSearchDeatil();
//   }, [localStorage.getItem("SearchLocation"),crewValue,shootValue]);

  //Login Detail
  const handleCloseLoginPopup = () => {
    setShowLoginPopup(false);
  };
  const handleLoginClick = () => {
    setShowLoginPopup(true);
  };
//Login Detail end
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 0 },
      items: 1,
    },
  };

  const checkHandler = () => {
    if (checkedMap == true) {
      setCheckedMap(false);
    } else {
      setCheckedMap(true);
    }
  };

  const handleCallback = (data) => {
    setSearchResultValue(data);
  };

  const Navigate = useNavigate();
  const smoothScroll = (URL, id) => {
    Navigate({
      pathname: URL,
      search: "?property-detail=" + id,
    });
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  const LocationDetailSearch = (path) => {
    //alert(path);
  };
  const handlePriceHotel = (price) => {
    console.log(price);
  };
  const handlePopertyType = (type) => {
    
      setPropertyType(type);
      localStorage.setItem("setPropertyTypeFilter", type);
     
    
  };
///console.log(propertyType)
 
  let TotalNum = "";
  let CityName = searchCityValue;
 
  if (searchResultValue != undefined) {
    TotalNum = searchResultValue.data.total;

    CityName = localStorage.getItem("setLocationNameSearch");
  }



  return (
    <div className={CommonStyle.searchResultPage + " " + CommonStyle.headerSpace} id="homeSection">
     <Helmet>      
        <title>{CityName}</title>
         <meta name="title" content={CityName} />
    </Helmet>
      <div className={CommonStyle.breadCrumb}>
        <Container>
          <Row>
            <Col>
              <ul>
                <li><Link to="/" onClick={smoothScroll}>Home</Link></li>
                <li>Search Results</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
      <div className={CommonStyle.SearchFilter}>
        <Container>
          <Row>
            <Col>
              <div className={CommonStyle.responsiveView + ' ' + CommonStyle.tabSearch}>
                <button type="button" onClick={showSearchHandler} className={ ButtonStyle.defaultButton + " " + CommonStyle.tabSearchButton}>
                      Search Now <LuSearch className={ButtonStyle.buttonArrow} />
                </button>
              </div>
              {searchBox && 
                <div className={CommonStyle.searchOverLay}>
                  <div className={CommonStyle.tabSerachContainer}>
                    <button type='button' onClick={closeSearchHandler} className={CommonStyle.closeSearch}><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M25.1111 10.8889L10.8889 25.1111M10.8889 10.8889L25.1111 25.1111M34 18C34 26.8366 26.8366 34 18 34C9.16345 34 2 26.8366 2 18C2 9.16345 9.16345 2 18 2C26.8366 2 34 9.16345 34 18Z" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
                    <Search parentCallback={handleCallback} />
                  </div>
                </div> 
              }
              <div className={CommonStyle.searchBrownBg + ' ' + CommonStyle.desktopView}>
                <Search parentCallback={handleCallback} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className={CommonStyle.searchresultArea}>
        <Container>
        <Row>
          <Col>
              <div>
                  <h2 className={CommonStyle.FlexCol + ' ' + FontStyle.Axiforma300 + ' ' + FontStyle.BlackColor}> 
                  360 <span className={FontStyle.Axiforma800 + ' ' + FontStyle.OrangeColor}>Virtual Tour</span>
                  </h2>
                  <img src={require('../../assest/images/360-tour.png')} className="tourImg" />
              </div>
          </Col>
        </Row>
         
          <>
          </>
          <Row>
            <Col>
              <div className={CommonStyle.cityArea}>
                <LocationCover/>
                <p>
                  Join our email list and be the first to know when we add new
                  spaces.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {showLoginPopup && <LoginPopup onClose={handleCloseLoginPopup} pageName={"SearchResult"}/>}
    </div>
  );
};

export default VirtualTour;
